export default {
  TOKEN: 'token',
  OAUTH_REDIRECTION: 'oauth_redirection',
  ORDERS: 'menu_orders',
};
